import { useToast } from 'vue-toastification'
import enums from '@/utils/enum'
import BaseHtml from '@/components/BaseHtml.vue'

function noteficationFromType(type) {
  const t = enums.notification.types
  switch (type) {
    case t.MESSAGE:
      return 'info'
    case t.ERROR:
      return 'error'
    case t.INFO:
      return 'info'
    case t.NETWORK:
      return 'success'
    case t.DANGER:
      return 'warning'
    default:
      return 'default'
  }
}

export default class Notification {
  constructor({
    msg = '',
    type = enums.notification.types.MESSAGE,
    severity = enums.notification.severity.INFO,
    config = {},
  } = {}) {
    this.msg = $t(msg)
    this.type = type
    this.severity = severity
    this.config = config
  }

  dispatch() {
    const toast = useToast()
    const note = this
    // https://maronato.github.io/vue-toastification/?ref=madewithvuejs.com
    const opts = {
      type: noteficationFromType(note.type),
      position: 'top-right',
      timeout: 4000,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 0.6,
      showCloseButtonOnHover: false,
      hideProgressBar: true, // Has to be false to remove it
      closeButton: 'button',
      icon: true,
      rtl: false,
      ...this.config,
    }
    const content = {
      component: BaseHtml,
      props: {
        html: note.msg,
      },
    }
    toast(content, opts)
  }
}
